import { Platform } from 'react-native';
import { useHeaderHeight } from '@react-navigation/elements';
import { spacing } from '@tabbio/tokens';

/**
 * Top padding for a native route viewport whose form owns its scrolling list.
 * iOS overlays the measured transparent header; Android's opaque header is
 * already outside the viewport. Do not add automatic insets for the same header.
 */
export function useSheetTopInset(): number {
  const headerHeight = useHeaderHeight();
  if (Platform.OS !== 'ios') return spacing[4];
  return (headerHeight > 0 ? headerHeight : 56) + spacing[4];
}
